import { Bell, CheckCheck } from 'lucide-react';
import useFetch from '../../hooks/useFetch';
import { useToast } from '../../context/ToastContext';
import { post, patch } from '../../api/client';
import { Card, Button, Badge, Loader, EmptyState, SectionTitle } from '../../components/UI';
import { fmtRelative } from '../../utils/format';

export default function AttendeeInbox() {
  const toast = useToast();
  const { data: rows, loading, reload } = useFetch('/notifications', { limit: 50 });

  const open = async (n) => {
    if (n.isRead) return;
    try { await patch(`/notifications/${n._id}/read`, {}); reload(); } catch { /* reading is best-effort */ }
  };

  const readAll = async () => {
    try { const res = await post('/notifications/read-all', {}); toast.success(res.message); reload(); }
    catch (err) { toast.error(err.message); }
  };

  if (loading) return <Loader full label="Loading your messages" />;
  const unread = (rows || []).filter((n) => !n.isRead).length;

  return (
    <>
      <SectionTitle
        title="Inbox"
        subtitle={unread ? `${unread} unread` : 'You are all caught up'}
        action={unread ? <Button variant="subtle" size="sm" icon={CheckCheck} onClick={readAll}>Mark all read</Button> : null}
      />
      {!rows?.length ? (
        <EmptyState message="No messages yet" hint="Updates from the organiser appear here." icon={Bell} />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 780 }}>
          {rows.map((n) => (
            <Card key={n._id} hover padding={16} onClick={() => open(n)}
              style={{ cursor: n.isRead ? 'default' : 'pointer', borderColor: n.isRead ? undefined : 'rgba(239,212,138,0.3)' }}>
              <div style={{ display: 'flex', gap: 11, alignItems: 'flex-start' }}>
                <span style={{ width: 8, height: 8, borderRadius: 99, marginTop: 7, flexShrink: 0, background: n.isRead ? 'transparent' : 'var(--gold-400)' }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <p style={{ fontSize: 14, fontWeight: n.isRead ? 500 : 600 }}>{n.title}</p>
                    {n.priority === 'high' && <Badge tone="warning">Important</Badge>}
                  </div>
                  <p style={{ fontSize: 13, color: 'var(--text-mid)', marginTop: 4, lineHeight: 1.6, whiteSpace: 'pre-line' }}>{n.body}</p>
                  <p style={{ fontSize: 11.5, color: 'var(--text-lo)', marginTop: 6 }}>{fmtRelative(n.createdAt)}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
